import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import UseAuth from '@connects/auth'

@UseAuth()
class PublicRoute extends React.Component {

	static propTypes = {
		redirectLoggedInUsers: PropTypes.bool,
		redirectTo: PropTypes.string,
	};

	static defaultProps = {
		redirectLoggedInUsers: true,
		redirectTo: '/dashboard',
	};

	render() {
		const { 
			loggedIn,
			redirectLoggedInUsers,
			redirectTo,
			...props
		} = this.props;

		return loggedIn && redirectLoggedInUsers
			? <Redirect to={redirectTo} />
			: <Route {...props} />
	}

}

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/components/PublicRoute.jsx